import React from "react";
import { alpha, Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import {
  Add as AddIcon,
  Business as BusinessIcon,
  Category as CategoryIcon,
} from "@mui/icons-material";

const EMERALD = "#059669";
const EMERALD_LIGHT = "#10b981";

const CostsHeader = ({ onAddCost, onAddCategory, onAddSupplier }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          p: 2.5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 4,
          flexDirection: isMobile ? "column" : "row",
          background: `linear-gradient(135deg, ${alpha(EMERALD, 0.04)} 0%, ${alpha(EMERALD_LIGHT, 0.08)} 100%)`,
          borderRadius: 3,
          border: `1px solid ${alpha(EMERALD, 0.1)}`,
          gap: isMobile ? 2 : 0,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<CategoryIcon />}
          onClick={onAddCategory}
          sx={{
            display: { xs: "none", sm: "flex" },
            borderColor: alpha(EMERALD, 0.3),
            color: EMERALD,
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              borderColor: EMERALD,
              backgroundColor: alpha(EMERALD, 0.04),
            },
          }}
        >
          Nova Categoria
        </Button>

        <Button
          variant="outlined"
          startIcon={<BusinessIcon />}
          onClick={onAddSupplier}
          sx={{
            display: { xs: "none", md: "flex" },
            mx: 2,
            borderColor: alpha(EMERALD, 0.3),
            color: EMERALD,
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              borderColor: EMERALD,
              backgroundColor: alpha(EMERALD, 0.04),
            },
          }}
        >
          Novo Fornecedor
        </Button>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddCost}
          sx={{
            minWidth: isMobile ? "100%" : "auto",
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            background: `linear-gradient(135deg, ${EMERALD} 0%, ${EMERALD_LIGHT} 100%)`,
            boxShadow: `0 4px 12px ${alpha(EMERALD, 0.3)}`,
            "&:hover": {
              boxShadow: `0 6px 20px ${alpha(EMERALD, 0.4)}`,
            },
          }}
        >
          Lancar Nota
        </Button>
      </Box>
    </motion.div>
  );
};

export default CostsHeader;
